import { getReadingTimeFromPageSections } from '@/data/sanity/pageFormatter/caseStudy'

export const blogPostFormatter = (data: SanityPage): SanityPage => {
  const sectionsAddedManually = data.sections || []

  // add author to last section block of type richTextSection
  if (data.blogPostData?.author && sectionsAddedManually?.length > 0) {
    const lastRichTextSectionIndex = sectionsAddedManually.findLastIndex(section => section._type === 'richTextSection')
    const lastRichTextSection = sectionsAddedManually[lastRichTextSectionIndex]
    if (lastRichTextSection) {
      lastRichTextSection.author = data.blogPostData?.author
    }
  }

  const readingTime = getReadingTimeFromPageSections(data.sections)

  const topSections = []

  topSections.push({
    _type: 'blogPostHero',
    title: data.title,
    summary: data.blogPostData?.summary,
    blogCategories: data.blogPostData?.blogCategories || [],
    author: data.blogPostData?.author,
    date: data.blogPostData?.publishedDate,
    readingTime,
  })

  if (data.blogPostData?.image) {
    topSections.push({
      _type: 'spacer',
      desktop: 'auto',
      mobile: 'auto',
    })

    topSections.push({
      _type: 'bigMedia',
      mediaAsset: data.blogPostData?.image,
      size: 'full',
    })
  }

  topSections.push({
    _type: 'spacer',
    desktop: 'auto',
    mobile: 'auto',
  })

  const sectionsWithSpacing = sectionsAddedManually
    .map((section, i) => {
      const nextSection = sectionsAddedManually[i + 1]
      const isLastSection = i === sectionsAddedManually?.length - 1

      if (section._type === 'quote' || section._type === 'introText') {
        return [
          section,
          {
            _type: 'spacer',
            desktop: 255,
            mobile: 100,
          },
        ]
      }

      if (section?._type === 'bigMedia' && nextSection?._type === 'richTextSection') {
        return [
          section,
          {
            _type: 'spacer',
            desktop: 'auto',
            mobile: 'auto',
          },
        ]
      }

      if (section._type === 'richTextSection' && isLastSection) {
        return [
          section,
          {
            _type: 'spacer',
            desktop: '0',
            mobile: '0',
          },
        ]
      }

      if (section._type === 'richTextSection' && nextSection) {
        if (section?._type === 'richTextSection' && nextSection?._type === 'introText') {
          return [
            section,
            {
              _type: 'spacer',
              desktop: '0',
              mobile: '0',
            },
          ]
        }

        if (section?._type === 'richTextSection' && nextSection?._type === 'bigMedia') {
          return [
            section,
            {
              _type: 'spacer',
              desktop: 'auto',
              mobile: 'auto',
            },
          ]
        }
      }

      return [
        section,
        {
          _type: 'spacer',
          desktop: 'auto',
          mobile: 'auto',
        },
      ]
    })
    .flat()

  data.sections = [...topSections, ...sectionsWithSpacing]

  return data
}
